import type { OrderView } from '@khaddi/contracts';
import { Button, Icon, Text, colors, formatVnd, radii, brandSurface } from '@khaddi/ui';
import { View } from 'react-native';

export const DeliveredScreen = ({ order, onDone, alreadyDone = false }: { order: OrderView; onDone: () => void; alreadyDone?: boolean }) => {
  const cod = order.paymentMethod === 'cod';
  return (
    <View style={{ flex: 1, ...brandSurface, padding: 24, justifyContent: 'center', gap: 24 }}>
      <View style={{ alignItems: 'center', gap: 14 }}>
        <View style={{ width: 96, height: 96, borderRadius: 48, backgroundColor: colors.mint, alignItems: 'center', justifyContent: 'center' }}>
          <Icon name="check" size={52} color={colors.navy} strokeWidth={3} />
        </View>
        <View accessibilityRole="header"><Text variant="display" color={colors.text} style={{ textAlign: 'center' }}>
          {alreadyDone ? 'Đơn đã hoàn tất' : 'Giao thành công!'}
        </Text></View>
        <Text variant="body" color={colors.text} style={{ textAlign: 'center' }}>
          Đơn #{order.code} · {order.delivery?.recipientName ?? order.customer?.name ?? 'Khách hàng'}
        </Text>
      </View>
      <View style={{ backgroundColor: 'rgba(255,255,255,.55)', borderRadius: radii.lg, padding: 16, gap: 10 }}>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
          <Text variant="body" color={colors.text}>
            Phí ship nhận được
          </Text>
          <Text variant="bodyStrong" color={colors.text} numeric>
            +{formatVnd(order.shipperFee)}
          </Text>
        </View>
        {cod ? (
          <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <Text variant="body" color={colors.text}>
              Tiền COD đã thu
            </Text>
            <Text variant="bodyStrong" color={colors.text} numeric>
              {formatVnd(order.pricing.total)}
            </Text>
          </View>
        ) : null}
        {cod ? (
          <Text variant="caption" color={colors.text}>
            Nhớ nộp lại tiền COD cho quán cuối ca để đối soát.
          </Text>
        ) : null}
      </View>
      <Button label="Về trang nhận đơn" onPress={onDone} variant="secondary" />
    </View>
  );
};
